import Grid from '@mui/material/Grid2';
import { withStyles } from '@mui/styles';
import { COLORS } from '../../../utils/Application_Constants';

const styles = () => ({
    listViewBodyRow: {
        flexWrap: 'nowrap',
        height: '100%',
        '&:hover > div': {
            // " > " is used to select the direct child of the parent (body-cell), otherwise hover style fails on rows when table overflows horizontally
            transition: '.25s',
            background: COLORS.LT_MIDNIGHTBG1,
        },
        '& > div': {
            // " > " is used to select the direct child of the parent (body-cell), otherwise border bottom fails on rows when table overflows horizontally
            borderBottom: `1px solid ${COLORS.LT_MIDNIGHT5}`,
        },
    },
    firstRow: {
        '& > div': {
            borderTop: `1px solid ${COLORS.LT_MIDNIGHT5}`,
        },
    },
    noBorder: {
        '& > div': {
            borderBottomColor: 'transparent',
            borderBottomWidth: 0,
        },
    },
    noHover: {
        '&:hover > div': {
            transition: 'none',
            background: 'none',
        },
    },
});

function ListViewBodyRow({ classes, children, index, noHover = false, noBorder = false, ...rest }) {
    return (
        <Grid
            container
            className={[
                classes.listViewBodyRow,
                index === 0 && classes.firstRow,
                noHover && classes.noHover,
                noBorder && classes.noBorder,
            ]}
            {...rest}
        >
            {children}
        </Grid>
    );
}

export default withStyles(styles)(ListViewBodyRow);
